var _title, _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatFill = function SvgChatFill(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1089,
    height: 1024,
    viewBox: "0 0 1089 1024",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M57.335 0h974.692c31.665 0 57.335 25.67 57.335 57.335v714.704c0 31.665-25.67 57.335-57.335 57.335h-92.219v194.627l-243.403-194.627h-639.070c-31.665 0-57.335-25.67-57.335-57.335v-714.704c0-31.665 25.67-57.335 57.335-57.335zM129.368 370.832v109.083h818.744v-109.083h-818.744zM129.368 152.666v109.083h818.744v-109.083h-818.744zM129.368 588.999v109.083h550.177v-109.083h-550.177z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-fill.f29b9b3d.svg";
export { ForwardRef as ReactComponent };